export default __webpack_public_path__ + "static/media/element_53.5a2d8df3.webp";